import { TestIds } from 'constants/tests';

const PageLoading = () => {
    return (
        <div
            data-testid={TestIds.Global.PageLoading}
            className="flex min-h-screen flex-col items-center justify-center gap-10"
        >
            <img alt="Givebutter Dashboard" src={`/images/logo.svg`} className="w-28" />
            <p className={'text-sm'}>Loading your dashboard...</p>
        </div>
    );
};

export { PageLoading };
